import React, {useContext} from "react";
import {ShiftRequestManagementContext} from "../ShiftRequestManagement";
import {Col, Row} from "antd";
import {
    CompanyFilter,
    SubCompanyFilter,
    CityFilter
} from "../../_defaultComponents/FilterComponents";
import {ShiftRequestManagementFilterStatus} from "./shiftRequestManagementFilterStatus/ShiftRequestManagementFilterStatus";

export const ShiftRequestManagementFilter = () => {
    const {
        selectedCompany,
        selectedSubCompany,
        setSelectedCompany,
        setSelectedSubCompany,
        selectedCity,
        setSelectedCity,
        setSelectedStatus,
        selectedStatus
    } = useContext(ShiftRequestManagementContext);

    return (
        <Col span={24}>
            <Row gutter={[20, 20]}>
                <Col xs={24} sm={16} md={12} lg={8} xl={6}>
                    <CompanyFilter value={selectedCompany} onChange={setSelectedCompany} />
                </Col>
                <Col xs={24} sm={16} md={12} lg={8} xl={6}>
                    <SubCompanyFilter
                        value={selectedSubCompany}
                        onChange={setSelectedSubCompany}
                        company={selectedCompany}
                        disabled={!selectedCompany}
                        showAllOption={false}
                        allowClear={true}
                    />
                </Col>
                <Col xs={24} sm={16} md={12} lg={8} xl={6}>
                    <CityFilter value={selectedCity} onChange={setSelectedCity} allowClear={true} />
                </Col>
                <Col xs={24} sm={16} md={12} lg={8} xl={6}>
                    <ShiftRequestManagementFilterStatus
                        value={selectedStatus}
                        onChange={setSelectedStatus}
                        showAllOption={true}
                        allowClear={true}
                    />
                </Col>
            </Row>
        </Col>
    );
};
